const items = ['footer', 'page', 'hero', 'model'];

const zIndex = (item) => items.length - items.indexOf(item);

export default zIndex;
